import React from 'react'

import './MapAssets.sass'
import { useMap, useMapLastPosition, useMapMarkers } from './useMap'
import { Asset } from 'src/types'

const MapAssets = ({ assets = [] }: { assets: Asset[] }) => {

  const theMap = useMap('map-assets')
  useMapMarkers(theMap, assets)
  // useMapSelf(theMap)
  useMapLastPosition(theMap)

  return <div id="map-assets" />
}

export default MapAssets
